import React from 'react';
import { Link } from 'gatsby';
import marked from 'marked';

const rightsDetailsList = (source, aggregator) => {
	switch (source.data.Rights_Details_Group) {
		case 'Direct / Specific-license-or-words':
			return (
				<>
				<li>
					Labelled {licenseLink(source.data.Rights, source.data.Rights_Prose, source.data.Rights_License_URL)} by source
				</li>
				{source.data.Rights_Page && (source.data.Rights_Page.length > 0) && (
					<li>
						See their general <a href={source.data.Rights_Page} target="_blank" rel="noopener noreferrer">rights page</a>
					</li>
				)}
				<li>
					We offer this info as <Link to="/reusing-material#guidance-only">guidance only</Link>
				</li>	
				</>
			);
		case 'Direct / Hands-off':
			return (
				<>
				<li>
					Source{' '}
					<span
						dangerouslySetInnerHTML={{ __html: marked(source.data.Rights_Prose).replace('<p>','').replace('</p>','') }}
					/>
				</li>
				{source.data.Rights_Page && (source.data.Rights_Page.length > 0) && (
					<li>
						See their general <a href={source.data.Rights_Page} target="_blank" rel="noopener noreferrer">rights page</a>
					</li>
				)}
				<li>
					We offer this info as <Link to="/reusing-material#guidance-only">guidance only</Link>
				</li>	
				</>
			);
		case 'Aggregated / Hands-off':
			return (
				<>
				<li>
					Source{' '}
					<span
						dangerouslySetInnerHTML={{ __html: marked(source.data.Rights_Prose).replace('<p>','').replace('</p>','') }}
					/>
				</li>
				{source.data.Rights_Page && (source.data.Rights_Page.length > 0) && (
					<li>
						See their general <a href={source.data.Rights_Page} target="_blank" rel="noopener noreferrer">rights page</a>
					</li>
				)}
				<li>
					We offer this info as <Link to="/reusing-material#guidance-only">guidance only</Link>
				</li>	
				</>
			);
		case 'Aggregated / Specific-license-or-words':
			return (
				<>
				<li>
					Labelled {licenseLink(source.data.Rights, source.data.Rights_Prose, source.data.Rights_License_URL)} by source
				</li>
				<li>
					We offer this info as <Link to="/reusing-material#guidance-only">guidance only</Link>
				</li>	
				</>
			);
		case 'Aggregated / Unmarked':
			return (
				<>
				{(source.data.Title !== 'Internet Archive') && (
					<li>
						<span
							dangerouslySetInnerHTML={{ __html: marked(source.data.Rights_Prose).replace('<p>','').replace('</p>','') }}
						/>
					</li>
				)}
				{aggregator && (aggregator.data.Title === 'Internet Archive') && (
					<li>
						Internet Archive has <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noopener noreferrer">CC BY-NC-SA</a> default which this might fall under
					</li>
				)}
				<li>
					We offer this info as <Link to="/reusing-material#guidance-only">guidance only</Link>
				</li>	
				</>
			);
		case 'Aggregated / Email-confirmed':
			return (
				<>
				<li>
					<span
						dangerouslySetInnerHTML={{ __html: marked(source.data.Rights_Prose).replace('<p>','').replace('</p>','') }}
					/>. However, source confirmed by email no additional rights.
				</li>
				<li>
					We offer this info as <Link to="/reusing-material#guidance-only">guidance only</Link>
				</li>	
				</>
			);
		case 'Non-Commercial':
			return (
				<>
				<li>
					Source labels this as{' '}
					<span
						dangerouslySetInnerHTML={{ __html: marked(source.data.Rights_Prose).replace('<p>','').replace('</p>','') }}
					/>
				</li>
				{source.data.Rights_Page && (source.data.Rights_Page.length > 0) && (
					<li>
						See their general <a href={source.data.Rights_Page} target="_blank" rel="noopener noreferrer">rights page</a>
					</li>
				)}
				<li>
					We offer this info as <Link to="/reusing-material#guidance-only">guidance only</Link>
				</li>	
				</>
			);
		default:
			return null;
	}
};

const digitalRightsLink = (rightsSummary) => {
	let anchorSlug;

	switch (rightsSummary) {
		case 'No Additional Rights':
			anchorSlug = 'no-additional-rights';
			break;
		case 'Attribution':
			anchorSlug = 'attribution';
			break;
		case 'Attribution-ShareAlike':
			anchorSlug = 'share-alike';
			break;
		case 'Non-commercial':
			anchorSlug = 'non-commercial';
			break;
		case 'Unclear':
			anchorSlug = 'unclear';
			break;
		default:
			anchorSlug = '';
	}
	
	return (
		<a href={`/rights-labelling-on-our-site#${anchorSlug}`}>
			{rightsSummary}
		</a>
	);
};

const licenseLink = (rights, rightsProse, rightsURL) => {
	if (rights && rights.length > 0) {
		if (rightsURL) {
			return (
				<a href={rightsURL} target="_blank" rel="noopener noreferrer">{rightsProse}</a>
			);
		}
		
		return rightsProse;
	}

	return rightsProse;
};

const DigitalRightsBlock = (props) => {
	const source = props.source;
	const aggregator = props.aggregator;
	
	if (props.source.data.Title === 'Wikimedia Commons') {
		return (
			<>
				<p>
					<b>
						<a href={`/rights-labelling-on-our-site#pd-wikimedia`}>
							PD Wikimedia
						</a>
					</b>
				</p>
				<ul>
					<li>
						Marked rights free on Wikimedia but not officially by creator of digital copy
					</li>
					<li>
						See their <a href="https://commons.wikimedia.org/wiki/Commons:When_to_use_the_PD-Art_tag" target="_blank" rel="noopener noreferrer">page outlining policy</a>
					</li>
					<li>
						We offer this info as <Link to="/reusing-material#guidance-only">guidance only</Link>
					</li>
				</ul>
			</>
		);
	}
	
	return (
		<>
			<p>
				<b>{digitalRightsLink(source.data.Rights_Summary)}</b>
			</p>
			<ul>
				{rightsDetailsList(source, aggregator)}
			</ul>
		</>
	);
};

export default DigitalRightsBlock;